// extracted by css-extract-rspack-plugin
export default {"playgroundContainer":"ModelsPlaygroundRoute-module__playgroundContainer__HgKAqH6","playgroundPanel":"ModelsPlaygroundRoute-module__playgroundPanel__km5QKL3"};